import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const ConfettiLeft = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="55"
        viewBox="0 0 40 55"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35.9772 4.79174C36.1962 4.51916 36.1175 4.23372 35.9666 3.95745C35.6186 3.32005 35.2719 2.68149 34.9052 2.05479C34.7158 1.73116 34.4568 1.60111 34.0913 1.84847C33.427 2.29808 32.7504 2.72949 32.0776 3.16644C31.6886 3.4191 31.741 3.74388 31.9346 4.08066C32.2703 4.64227 32.5477 5.23674 32.7626 5.85479C32.9295 6.36222 33.2796 6.42232 33.7192 6.28476C34.6102 6.00594 35.246 5.33774 35.9772 4.79174Z"
            fill="#F85520"
        />
        <path
            d="M22.2029 12.7516C21.4037 12.7209 20.8966 13.0668 20.6681 13.8214C20.3879 14.7464 20.1091 15.6719 19.8438 16.6012C19.7604 16.8934 19.745 17.2531 19.9811 17.4385C21.0597 18.2851 22.4233 18.3163 23.6709 18.4067C24.5889 18.4732 24.969 17.4834 25.1345 16.6106C25.2669 15.9495 25.4784 15.3068 25.7643 14.6962C26.0988 13.9589 25.7835 13.4189 25.0572 13.2405C24.1221 13.0108 23.1558 12.9087 22.2029 12.7516Z"
            fill="#FCD26A"
        />
        <path
            d="M1.95833 19.5206C2.15628 20.4425 2.69926 20.9211 3.62797 20.9622C4.76635 21.0126 5.90493 21.0614 7.04393 21.0936C7.40203 21.1037 7.81751 21.0164 7.96041 20.6927C8.61317 19.2137 8.25135 17.6467 7.99099 16.1951C7.7994 15.127 6.55781 14.9812 5.51243 15.0466C4.71862 15.088 3.92271 15.0338 3.14184 14.8851C2.20193 14.7179 1.67703 15.2355 1.6849 16.1173C1.69505 17.2525 1.86005 18.3863 1.95833 19.5206Z"
            fill="#BEB3FF"
        />
        <path
            d="M11.7931 41.8947C11.8814 43.3593 12.7075 44.0735 14.2238 43.9962C15.832 43.9142 17.1048 42.7105 17.0541 41.3194C17.0152 40.2502 15.6986 39.0849 14.6271 39.1712C12.7157 39.325 11.6972 40.3038 11.7931 41.8947Z"
            fill="#FCD26A"
        />
        <path
            d="M26.1052 49.252C24.9044 49.4057 23.8617 49.8296 23.1757 50.9412C22.7654 51.6062 22.5976 52.2255 23.0217 52.9438C23.2044 53.2571 23.4771 53.5082 23.8045 53.6643C24.1318 53.8205 24.4985 53.8745 24.857 53.8193C25.8735 53.7453 26.8361 53.3339 27.5921 52.6504C28.3027 51.994 28.5213 51.2167 28.1641 50.3692C28.02 49.9613 27.7297 49.6212 27.3494 49.4148C26.9691 49.2085 26.5258 49.1505 26.1052 49.252Z"
            fill="#BEB3FF"
        />
        <path
            d="M27.0415 39.063C26.6386 34.9498 21.0014 30.1077 18.0579 31.2123C16.4279 31.824 17.8252 33.6439 19.7345 33.479C22.0215 33.2815 23.4616 32.138 22.2701 29.5638C21.0448 26.9168 14.3182 22.5712 5.99361 24.7544"
            stroke="#F85520"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ConfettiLeftIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={ConfettiLeft}
        fontSize={fontSize}
    />
);
